







































import { Vue, Component, Prop } from 'vue-property-decorator';

import { IPayment } from '@/interfaces/Payment';
import { IInvoice } from '@/interfaces/Checkout';

import { EPaymentMethod } from '@/helpers/enums';

@Component
export default class PlanText extends Vue {
  @Prop()
  private invoice!: IInvoice;

  @Prop()
  private payment!: IPayment;

  private get installmentsNumber(): number {
    return (
      this.invoice &&
      this.invoice.paymentMethodInstallments &&
      this.invoice.paymentMethodInstallments.number
    );
  }

  private get installmentsPrice(): number {
    return (
      this.invoice &&
      this.invoice.paymentMethodInstallments &&
      this.invoice.paymentMethodInstallments.amount
    );
  }

  private get paymentMethods() {
    return EPaymentMethod;
  }
}
